// src/components/AdminDashboard.js
import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import AddOdbiorca from "./dictionaries/AddOdbiorca";
import AddSamochod from "./dictionaries/AddSamochod";
import AddOddzial from "./dictionaries/AddEgz";
import AddMaterial from "./dictionaries/AddMaterial";
import AddFirma from "./dictionaries/AddFirma";
import AddUser from "./dictionaries/AddUser";
import AddCennik from "./dictionaries/AddCennik";
import AddPrzeznaczenie from "./dictionaries/AddPrzeznaczenie";
import "../css/AdminDashboard.css";
// import AddTransport from "./dictionaries/AddTransport";

// Nagłówek zakładki: ikona + etykieta
const tabHeader = (icon, label) => (
  <span className="admin-tab">
    <i className={`pi ${icon} admin-tab-icon`} />
    <span className="admin-tab-label">{label}</span>
  </span>
);

const AdminDashboard = ({ token }) => {
  return (
    <div className="admin-page">
      <div className="admin-header">
        <div className="admin-header-icon">
          <i className="pi pi-cog" />
        </div>
        <div>
          <h1>Panel administracyjny</h1>
          <p className="admin-subtitle">
            Zarządzanie użytkownikami, firmami i słownikami systemu
          </p>
        </div>
      </div>

      <div className="admin-tabs-card">
        <TabView>
          <TabPanel header={tabHeader("pi-users", "Użytkownicy")}>
            <AddUser token={token} />
          </TabPanel>
          <TabPanel header={tabHeader("pi-building", "Firmy")}>
            <AddFirma token={token} />
          </TabPanel>
          <TabPanel header={tabHeader("pi-sitemap", "Oddziały")}>
            <AddOddzial token={token} />
          </TabPanel>
          <TabPanel header={tabHeader("pi-id-card", "Odbiorcy")}>
            <AddOdbiorca token={token} />
          </TabPanel>
          <TabPanel header={tabHeader("pi-car", "Samochody")}>
            <AddSamochod token={token} />
          </TabPanel>
          <TabPanel header={tabHeader("pi-box", "Materiały")}>
            <AddMaterial token={token} />
          </TabPanel>
          <TabPanel header={tabHeader("pi-tags", "Przeznaczenia")}>
            <AddPrzeznaczenie token={token} />
          </TabPanel>
          <TabPanel header={tabHeader("pi-money-bill", "Cennik")}>
            <AddCennik token={token} />
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};

export default AdminDashboard;
